import { Authorized } from "@oysterhr/auth"
import { PropsWithChildren, ReactNode } from "react"
import { Outlet, useOutletContext } from "react-router-dom"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { UnauthorizedPage } from "~/shared/pages/system"
import type { AspectPermission } from "~/router/type"

type Props = {
  permissions: AspectPermission[]
  children?: ReactNode
}
export const PermissionProtectedRoute = ({ permissions, children }: PropsWithChildren<Props>) => {
  const parentContext = useOutletContext()
  const { currentAspect, isCompany } = useAccountAspect()

  return (
    <Authorized
      to={isCompany ? permissions : []}
      on={currentAspect}
      fallback={<UnauthorizedPage />}
    >
      {children ? <>{children}</> : <Outlet context={parentContext} />}
    </Authorized>
  )
}
